(() => {
  const key = 'salted_signup_expires_v2';
  const offerDuration = 7 * 24 * 60 * 60 * 1000;
  let expires = 0;
  let expiryTimer;
  let renderQueued = false;
  try { expires = Number(localStorage.getItem(key)) || 0; } catch {}

  function renderCode() {
    renderQueued = false;
    const remembered = expires > Date.now();
    const eligible = Boolean(document.querySelector('[data-salted-eligible]'));
    document.querySelectorAll('[data-salted-code-box]').forEach((box) => {
      box.hidden = !(remembered || eligible);
    });
    document.querySelectorAll('[data-salted-signup-cta]').forEach((cta) => {
      cta.hidden = remembered || eligible;
    });
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(renderCode);
  }

  function setExpiryTimer() {
    clearTimeout(expiryTimer);
    if (expires > Date.now()) {
      expiryTimer = setTimeout(renderCode, expires - Date.now() + 50);
    }
  }

  async function openSignup() {
    const drawer = document.getElementById('cart-drawer');
    const panel = drawer?.querySelector('dialog[open]');
    if (panel) {
      if (typeof drawer.close === 'function') await drawer.close();
      else panel.close();
    }
    const form = document.querySelector('footer [data-salted-newsletter] form') ||
      document.querySelector('[data-salted-newsletter] form');
    if (!form) {
      window.location.assign('/#contact_form');
      return;
    }
    form.scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'center'
    });
    form.querySelector('input[type="email"]')?.focus({ preventScroll: true });
  }

  async function copyCode(button) {
    const error = button.closest('[data-salted-code-box]')?.querySelector('[data-salted-copy-error]');
    if (error) error.hidden = true;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(button.dataset.saltedCopy);
      button.textContent = button.dataset.copiedLabel;
      setTimeout(() => { button.textContent = button.dataset.copyLabel; }, 2000);
    } catch {
      if (error) error.hidden = false;
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const open = event.target.closest('[data-salted-open-signup], a[href$="#salted-cart-signup"]');
    if (open) {
      event.preventDefault();
      event.stopImmediatePropagation();
      void openSignup();
      return;
    }
    const copy = event.target.closest('[data-salted-copy]');
    if (copy) {
      event.preventDefault();
      void copyCode(copy);
    }
  }, true);

  function initialize() {
    if (document.querySelector('[data-salted-signup-success]') && !expires) {
      expires = Date.now() + offerDuration;
      try { localStorage.setItem(key, String(expires)); } catch {}
    }
    renderCode();
    setExpiryTimer();
    const observer = new MutationObserver(queueRender);
    observer.observe(document.body, { childList: true, subtree: true });
    if (location.hash === '#salted-cart-signup') void openSignup();
  }

  window.addEventListener('storage', (event) => {
    if (event.key !== key) return;
    expires = Number(event.newValue) || 0;
    renderCode();
    setExpiryTimer();
  });
  window.addEventListener('pageshow', renderCode);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
